/* eslint-disable @typescript-eslint/consistent-type-definitions */
import type {
  ConfigSensorName,
  SensorConfigKey,
} from "@/base/sensor-configurations"
import type {
  SupportProductId,
  SupportTopicId,
} from "@/constants/support-documentation"

import React from "react"
import { Platform } from "react-native"

import { FONT_SIZES, getFontName } from "@/theme"

import { Help } from "./Help"

import type { NativeStackNavigationOptions } from "@react-navigation/native-stack"
import type { Simplify } from "type-fest"
import type { HelpContentProp } from "@/components/HelpContent"

export const SCREEN_DEFAULTS: NativeStackNavigationOptions = {
  headerTitleStyle: {
    fontFamily: getFontName("Poppins_600SemiBold"),
  },
}
export const HEADER_LARGE_DEFAULTS: NativeStackNavigationOptions = {
  ...SCREEN_DEFAULTS,
  ...Platform.select<NativeStackNavigationOptions>({
    ios: {
      headerBlurEffect: "systemMaterialLight",
      headerLargeTitle: true,
      headerLargeTitleStyle: {
        fontFamily: getFontName("Poppins_600SemiBold"),
        fontSize: FONT_SIZES.$h2,
      },
      headerTransparent: true,
    },
    web: {
      headerShown: false,
    },
  }),
}

interface MakeScreenOptions extends NativeStackNavigationOptions {
  headerLarge?: boolean
  helpContent?: HelpContentProp
}

export function makeScreenOptions(
  options?: MakeScreenOptions,
): NativeStackNavigationOptions {
  const { headerLarge, helpContent, ...rest } = options ?? {}
  const helpElement = Boolean(helpContent) ? (
    <Help content={helpContent} />
  ) : null

  let result: NativeStackNavigationOptions = { ...SCREEN_DEFAULTS }

  if (headerLarge === true) {
    result = {
      ...result,
      ...HEADER_LARGE_DEFAULTS,
    }
  }

  return {
    ...result,
    ...Platform.select({
      android: {
        headerRight: Boolean(helpElement) ? () => helpElement : undefined,
      },
      ios: {
        headerRight: Boolean(helpElement) ? () => helpElement : undefined,
      },
    }),
    ...rest,
  }
}

export type SupportPageRouteParams = {
  productId: SupportProductId
  topicId: SupportTopicId
}

export type VerifyPhoneNumberRouteParams = ReferrerRouteParam & {
  verifyingId: string
}
export type ConfirmSignUpRouteParams = {
  email?: string
}

export type FieldProfileRouteParams = {
  fieldId: string
}

export type ManageSensorRouteParams = {
  sensorName: ConfigSensorName
}
export type EditSensorFieldRouteParams = {
  fieldName: SensorConfigKey
  sensorName: ConfigSensorName
}
export type ReferrerRouteParam = {
  from?: string
}

export type DeviceProfileRouteParams = {
  codaDeviceAlias: string
}
export type CreateConnectionRouteParams = {
  initiatorDeviceId: string
}
export type GlobalSearchParams = Simplify<
  CreateConnectionRouteParams &
    DeviceProfileRouteParams &
    EditSensorFieldRouteParams &
    FieldProfileRouteParams &
    ManageSensorRouteParams &
    ReferrerRouteParam
>
